const HandCashIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M1.66669 9.16676L3.89275 6.66243C4.59705 5.87009 5.60657 5.41675 6.66669 5.41675V5.41675"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M1.66669 16.2505L6.25002 16.2502L9.58335 13.7505C9.58335 13.7505 10.2576 13.2942 11.25 12.5004C13.3334 10.8338 11.25 8.19484 9.16669 9.5833C7.47009 10.714 5.83335 11.6671 5.83335 11.6671"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66669 11.2501V6.16675C6.66669 5.06218 7.56212 4.16675 8.66669 4.16675H16.3334C17.4379 4.16675 18.3334 5.06218 18.3334 6.16675V10.5001C18.3334 11.6047 17.4379 12.5001 16.3334 12.5001H11.25"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M12.5 10.0001C11.5795 10.0001 10.8334 9.25389 10.8334 8.33341C10.8334 7.41294 11.5795 6.66675 12.5 6.66675C13.4205 6.66675 14.1667 7.41294 14.1667 8.33341C14.1667 9.25389 13.4205 10.0001 12.5 10.0001Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16.25 8.34159L16.2583 8.33233" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8.75 8.34159L8.75833 8.33233" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default HandCashIcon;
